import { DataBean } from "../DataBean";

export class WorkActivityRelationGroup extends DataBean {

  public async getWorkActivityRelationGroupCatalogPorPropiedades(properties: any, maxRows?: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getWorkActivityRelationGroupCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getWorkActivityRelationRender(page: number, rows: number, props: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.shared.Report_getWorkActivityRelationRender_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }

  public async deleteWorkActivityRelationGroup(idworkactivityrelationgroup: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "boolean_deleteWorkActivityRelationGroup_Number",
      [idworkactivityrelationgroup]
    );
  }

  public async updateWorkActivityRelationGroup(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.WorkActivityRelationGroup_updateWorkActivityRelationGroup_com.advantage.processflow.bean.WorkActivityRelationGroup",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.advantage.processflow.bean.WorkActivityRelationGroup",
        },
      ]
    );
  }
}
